// treatementPageTracking
export function getTreatementPageTrack(type, data) {
  return {
    type: type,
    payload: data,
  };
}
